export default __webpack_public_path__ + "static/media/BeatTheBox.167e425b.pdf";